<template>
  <div>
    <div v-if="state === 'loading'" class="wc-loading">加载中...</div>
    <empty-state
      v-else-if="state === 'empty'"
      :text="emptyText"
      :action-text="emptyActionText"
      @action="$emit('empty-action')"
    />
    <empty-state v-else-if="state === 'error'" text="网络开小差了，加载失败" retry @retry="$emit('retry')" />
    <slot v-else />
  </div>
</template>

<script>
import EmptyState from './EmptyState.vue'

export default {
  name: 'WorldCupLoadState',
  components: { EmptyState },
  props: {
    state: {
      type: String,
      default: 'idle'
    },
    emptyText: {
      type: String,
      default: '暂无数据'
    },
    emptyActionText: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
.wc-loading {
  padding: 36px 0;
  text-align: center;
  color: #8a9099;
  font-size: 14px;
}
</style>
